import {makeStyles} from '@material-ui/core';
import clsx from 'clsx';
import UtilService from '../../../../../helper/service';
import DotMenuListing from "../../../../atoms/creator/dashboardDotMenuListing";
import roles from "../../../../../helper/roles";
import {useHistory} from "react-router";

const darkImages = [8, 9, 12, 13, 14, 15, 16, 17, 32, 33, 36, 40, 44, 48, 49, 50, 51, 52, 54, 55, 56, 61, 65, 68, 69, 70];

const useStyles = makeStyles(() => ({
  creatorDashboardCircle : {
   
    height:"41px",
    width:"41px",
    fontWeight:"bold",
    paddingTop: "0",
    paddingLeft: "0",
    borderRadius: '50%',
    fontSize: '14px',
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  },
  creatorDashboardCircleUsername : {
    
    height:"41px",
    width:"41px",
    fontWeight:"bold",
    paddingTop: "0",
    paddingLeft: "0",
    borderRadius: '50%',
    fontSize: '14px',
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  },
  tr: {
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    fontSize: 12,
    cursor: 'pointer',
    borderBottom: '1px solid #F5F5F5',
    '& div': {
      textAlign: 'left',
    },
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  img: {
    width: 120,
    height: 72,
    borderRadius: 10,
    marginRight: 25,
    objectFit: 'cover'
  },
  healthyText: {
    color: '#1DB859',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  m8: {
    margin: '0 8px'
  },
  clips: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'end',
    '&:hover': {
      cursor: 'pointer'
    },
    '& div': {
      fontFamily: 'roboto-regular',
      fontSoze: 14,
      marginRight: 8
    },
  },
  opened: {
    marginTop: '22px!important',
  },
  muted: {
    color: '#017AEF'
  },
  rotate: {
    transform: 'rotate(90deg)',
  },
  imgDiv: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mp3Icon: {
    width: '38px',
    height: '38px',
    position: 'absolute',
    textAlign: 'center',
    marginLeft: '-33px',
  },
  dotMenu: {
    position: "relative",
    marginLeft: "-25px",
  },
  opacity0: {
    opacity: 0,
  },
  opacity1: {
    opacity: 1,
  },

  reelsImgCont: {
    width:"120px",
    height:"72px",
    position:"relative",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    borderRadius:10,
    background:"#46C690",
    marginRight:24,
    objectFit: 'cover'
  },
  reelsImgSvg: {
    position:"absolute",
    left:8,
    top:8
  },
  reelsImg: {
    width:15,
    position:"absolute",
    right:5,
    bottom:4,
    opacity:"0.5"
  },
  thumbnailDiv: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width:"120px",
    height:"72px",
    '@media screen and (max-width: 800px)': {
      marginRight: 0
    },
    zIndex: 0
  },
  startDateBlack: {
    position: 'absolute',
    fontSize: 12,
    fontFamily: 'Spartan-extrabold',
    color: '#212D40',
    textTransform: 'uppercase',
    marginRight: '25px'
  },
  startDateWhite: {
    position: 'absolute',
    fontSize: 12,
    fontFamily: 'Spartan-extrabold',
    color: '#ffffff',
    textTransform: 'uppercase',
    marginRight: '25px'
  },
  uppercase: {
    textTransform: 'uppercase'
  }
}));

export function CreatorReelsTableBody(props: any) {
  const classes = useStyles();
  const {
    renameExperiece, onAddRemvoeProject, deleteExperiece, item, HEADER, disableNavigation, initialHover,
    open, openReelsSessions, search, onSaveBenchmark, onRemoveBenchmark
  } = props;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
  const history = useHistory();

  const goManagerParticipantPage = () => {

    if (disableNavigation)
      return;

    if (!item.session_code) return;
    localStorage.setItem("session_code", String(item.session_code));
    localStorage.setItem("session_id", String(item.session_id));
    localStorage.setItem("session_name", String(item.name));

    const routertabname = 'participants';
    
    let url = `/creator/experience-manager/${routertabname}/${item.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/${routertabname}/${item.session_code}`;
    }
    history.push(url, { session_id: item.session_id });
  };
  
  const getHeaderLabelColor = (thumbnail : any) => {
    if (thumbnail) {
      const arrayPieces = thumbnail.split(/[\s/]+/);
      if (darkImages.includes(parseInt(arrayPieces[arrayPieces.length - 1].split('.')[0].split('-')[1]))) {
        return classes.startDateWhite
      } else {
        return classes.startDateBlack
      }
    } else {
      return classes.startDateBlack
    }
  };

  return (
    <div className={clsx(classes.tr, classes.m8, item.session_id === open && classes.opened)}>
      <div style={{ width: HEADER[0].width }}>
        {/* {(initialHover === item.session_id || (selected.findIndex((x: any) => x.session_id === item.session_id)) !== -1) && <Checkbox
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          color="primary"
          checked={(selected.findIndex((x: any) => item.session_id === x.session_id)) !== -1}
          style={{ marginLeft: -8 }}
        />} */}
      </div>

      <div style={{ width: HEADER[1].width }} className={classes.left} onClick={() => goManagerParticipantPage()}>
        {/* <div className={classes.imgDiv}> */}
          {
            (item.img || item.img_large) ?
              
              <div className={classes.thumbnailDiv}>
                <img
                  src={item.img ? item.img : item.img_large }
                  alt={'img'}
                  className={classes.img}
                  onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
                />
                <span style={{ font: "12px Spartan-bold", textAlign: "center" }} className={getHeaderLabelColor(item.img ? item.img : item.img_large)}>
                REEL<br />{UtilService.getOverviewExperienceStartDate(item.start)}
                  {(item.stimulus_type && item.stimulus_type === "AUDIO") && <img
                    src={`/assets/icons/mp3.svg`}
                    alt={'img'}
                    className={classes.mp3Icon}
                  />}
                </span>
              </div>
            :
              <div className={classes.reelsImgCont}>
                <svg className={classes.reelsImgSvg} xmlns="http://www.w3.org/2000/svg" width="11.861" height="8.12" viewBox="0 0 11.861 8.12">
                <g id="Group_160120" data-name="Group 160120" transform="translate(0.75 0.75)">
                <path id="Path_37625" data-name="Path 37625" d="M8.828,12.87H4.3a1.3,1.3,0,0,1-1.3-1.3V7.545a1.3,1.3,0,0,1,1.3-1.3H8.828a1.3,1.3,0,0,1,1.3,1.3v4.029A1.3,1.3,0,0,1,8.828,12.87Z" transform="translate(-3 -6.25)" fill="#212d40" stroke="#323232" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <path id="Path_37626" data-name="Path 37626" d="M15.375,10.763l2.185,1.758a.647.647,0,0,0,1.053-.5V8.247a.647.647,0,0,0-1.053-.5L15.375,9.5" transform="translate(-8.252 -6.822)" fill="#212d40" stroke="#323232" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <path id="Path_37627" data-name="Path 37627" d="M11.19,12.3V10" transform="translate(-6.476 -7.841)" fill="rgba(0,0,0,0)" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                <path id="Path_37628" data-name="Path 37628" d="M7.19,12.3V10" transform="translate(-4.778 -7.841)" fill="rgba(0,0,0,0)" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                </g>
                </svg>
                <span style={{font:"12px Spartan-bold", textAlign:"center", color:"#212D40"}}>REEL<br />{UtilService.getOverviewExperienceStartDate(item.start)}</span>
                <img alt="Logo" src="/static/big_logo.svg" className={classes.reelsImg}/>
              </div>
          }
        {/* </div> */}
        {item.name}
      </div>

      <div style={{ width: HEADER[2].width }} className={classes.uppercase} onClick={() => goManagerParticipantPage()}>
        { item.session_code }
      </div>

      <div style={{ width: HEADER[3].width }} onClick={() => goManagerParticipantPage()}>
        {item.survey_link && <img src={'/assets/icons/dashboard/check_icon.svg'} width='12px' height='12px' />}
      </div>

      <div
        className={classes.clips}
        style={{ width: HEADER[4].width}}
        onClick={() => openReelsSessions(open === item.session_id ? -1 : item.session_id, item.session_id, item.reel_sessions )}
      >
        <div className={clsx(item.clips && classes.muted)} style={{color:"#017AEF"}} >
          {item.reel_sessions && item.reel_sessions.length !== 0 ? item.reel_sessions.length : '-'}
        </div>
        {
          item.reel_sessions && item.reel_sessions.length !== 0  &&
          <img
            className={clsx(open === item.session_id && classes.rotate)}
            src={`/assets/icons/dashboard/right.svg`}
            alt="{icon}"
          />
        }
      </div>

      <div style={{ width: HEADER[5].width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.formattingString(item.status)}
      </div>

      <div style={{ width: HEADER[6]?.width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.getSimpleDate(item.start)}
      </div>

      <div style={{ width: HEADER[7]?.width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.getSimpleDate(item.end)}
      </div>

      <div style={{ width: HEADER[8]?.width }} onClick={() => goManagerParticipantPage()}>
        {item.participants}
      </div>

      {!search &&
        <div className={clsx(classes.dotMenu, classes.opacity0, initialHover === item.session_id && classes.opacity1)}>
          <DotMenuListing
            key={1}
            item_session={item}
            isreel = {true}
            copy_Experience={() => {}}
            onAddRemoveProject={() => onAddRemvoeProject(item)}
            delete_Experience={() => deleteExperiece(item)}
            rename_Experiece={() => renameExperiece(item)}
            onSaveBenchmark={() => onSaveBenchmark(item)}
            onRemoveBenchmark={() => onRemoveBenchmark(item)}
          />
        </div>
      }
    </div>
  )
}
